function getDayAutofocus(_ref) {
  var hasValue = _ref.hasValue,
      selected = _ref.selected,
      firstInMonth = _ref.firstInMonth;

  if (hasValue) {
    return selected ? true : void 0;
  }

  return firstInMonth ? true : void 0;
}

export { getDayAutofocus };